import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DBService } from '../../services/db.service';
import { AuthenticationService } from '../../services/authentication.service';
import { Partner } from '../../model/partner';
import { Address } from '../../model/company';
import { LocationService } from '../../services/location.service';

import * as firebase from 'firebase';

declare var Materialize: any;

@Component({
  selector: 'app-edit-partner',
  templateUrl: './edit-partner.component.html',
  styleUrls: ['./edit-partner.component.css'],
  providers: [DBService, LocationService]
})
export class EditPartnerComponent implements OnInit {

  phoneMask = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  cepMask = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  selectedFile: File;

  successMessage: string;
  errorMessage: string;

  partner: Partner;

  loading: boolean;
  isSearching: boolean;

  uid: string;

  initLoading: boolean;

  isUploadingFile: boolean;
  isCuttingFile: boolean;

  constructor(private router: Router, private dbService: DBService, private authService: AuthenticationService, private locationService: LocationService, private route: ActivatedRoute) { 
    this.partner = new Partner();
    this.partner.address = new Address();

    this.initLoading = true;

    this.route.params
    .subscribe(params => this.initData(params['id']));
  }

  private initData(uid: string) {
    this.uid = uid;
    this.dbService.getObject<Partner>(`partners/${this.uid}`)
      .then(partner => {
        this.partner = partner;

        this.initLoading = false;

        this.updateTextFields();
      });
  }

  private updateTextFields() {
    setTimeout(() => Materialize.updateTextFields(), 100);
  }

  ngOnInit() {
  }

  detectFiles(event) {
    this.selectedFile = event.target.files[0];
  }

  onChange(event) {
    const dateParts = this.partner.partnershipDateString.split('/');

    const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

    if (date.toString() === 'Invalid Date') {
      delete this.partner.partnershipDate;
    } else {
      this.partner.partnershipDate = date.getTime();
    }
  }

  private save() {
    this.loading = true;

    const updatingObj =  {
      account: this.partner.account,
      agency: this.partner.agency,
      bank: this.partner.bank,
      cpf: this.partner.cpf,
      email: this.partner.email,
      fileURL: this.partner.fileURL,
      name: this.partner.name,
      partnershipDate: this.partner.partnershipDate,
      partnershipDateString: this.partner.partnershipDateString,
      phone: this.partner.phone,
      address: {
        cep: this.partner.address.cep,
        city: this.partner.address.city,
        neighborhood: this.partner.address.neighborhood,
        number: this.partner.address.number,
        state: this.partner.address.state,
        street: this.partner.address.street
      }
    };

    if (this.partner.photoURL) {
      updatingObj['photoURL'] = this.partner.photoURL;
    }

    this.dbService.update(`partners/${this.uid}`, updatingObj)
      .then(() => this.saveSuccess())
      .catch(error => this.registerError(error));
  }

  private saveSuccess() {
    this.loading = false;

    Materialize.toast('Parceiro atualizado com sucesso', 2000);

    this.router.navigate(['/parceiros']);
  }

  private registerError(error) {
    this.errorMessage = error;
    this.loading = false;
  }

  cancel() {
    this.router.navigate(['/parceiros']);
  }

  searchCep() {
    this.isSearching = true;

    this.locationService.getAddress(this.partner.address.cep)
      .then(address => {
        address.cep = this.partner.address.cep;
        this.partner.address = address;
        this.isSearching = false;

        this.updateLabels();
      })
      .catch(error => {
        console.log(error);
        this.isSearching = false;
      });
  }

  private updateLabels() {
    setTimeout(() => Materialize.updateTextFields(), 100);
  }

  public fileChangeEvent($event: any) {
    if ($event.target.files && $event.target.files[0]) {
      this.uploadImage();
    }
  }

  uploadImage() {
    this.isUploadingFile = true;
    const storage = firebase.storage().ref();
    const path = '/partners/';
    const files = [(<HTMLInputElement>document.getElementById('custom-input')).files[0]];

    for (const image of files) {
      storage.child(path + image.name).put(image)
        .then((result) => {
          this.partner.photoURL = result.downloadURL;
          this.partner.photoURL = result.downloadURL;
          this.isUploadingFile = false;
        });
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/edit-partner/edit-partner.component.ts